// src/modules/app-views/_apps/appmulti/plans/pages/Document/cardHeaderItems.js
// Plan-specific items for CardHeaderColumn
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import {
  ApiOutlined,
  CompassOutlined,
  GlobalOutlined,
  SafetyCertificateOutlined,
  TagOutlined,
  TeamOutlined,
  TransactionOutlined,
} from '@ant-design/icons';
import translateX from 'utils/translateX';
import plansService from 'modules/app-views/_apps/appmulti/plans/service';
import financialService from 'services/financialService';

// *******************************************************************************
// ITEMS
// *******************************************************************************
export const planOperatorItem = record => {
  const operatorName = record?.__operator?.name;

  return {
    key: 'planOperator',
    icon: <TeamOutlined />,
    label: operatorName || null,
    tooltipText: translateX('operator'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const planPriceItem = record => {
  let label = null;
  const exchangeRate = record?.__operator?.parameters?.__exchangeRate;

  if (record?.priceType === 'table') {
    label = translateX('table');
  } else if (record?.price != null && record.price > 0) {
    const brlValue = exchangeRate ? record.price * exchangeRate : record.price;
    const brlFormatted = financialService.formatMoney({ value: brlValue, localeSymbol: 'brl', resultToStr: true });
    const usdSymbol = plansService.getCurrencySymbol(record?.currency);
    const usdFormatted = financialService.formatNumber(record.price, { decimals: 2, locale: 'pt-BR' });
    label = `${translateX('daily_price')}: ${brlFormatted} (${usdSymbol} ${usdFormatted})`;
  }

  return {
    key: 'planPrice',
    icon: <TagOutlined />,
    label,
    tooltipText: translateX('daily_price'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const coverageCountItem = record => {
  const count = record?.coverages?.length;
  if (!count) return { key: 'coverageCount', label: null };

  return {
    key: 'coverageCount',
    icon: <SafetyCertificateOutlined />,
    label: `${count} ${translateX('coverages').toLowerCase()}`,
    tooltipText: translateX('coverages'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const travelProfileItem = record => {
  const profiles = record?.__travelProfiles || {};
  const activeLabels = Object.entries(profiles)
    .filter(([, active]) => active)
    .map(([key]) => translateX(key))
    .join(', ');

  return {
    key: 'travelProfile',
    icon: <CompassOutlined />,
    label: activeLabels || null,
    tooltipText: translateX('travel_profile'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const apiOriginalNameItem = record => {
  const originalName = record?._integrations?.originalName;

  return {
    key: 'apiOriginalName',
    icon: <ApiOutlined />,
    label: originalName || null,
    tooltipText: translateX('original_name'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const planDestinationsItem = record => {
  const destinations = record?.destinations;
  const label =
    Array.isArray(destinations) && destinations.length
      ? destinations.map(d => translateX(d)).join(', ')
      : null;

  return {
    key: 'planDestinations',
    icon: <GlobalOutlined />,
    label,
    tooltipText: translateX('destinations'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const exchangeRateItem = record => {
  const rate = record?.__operator?.parameters?.__exchangeRate;
  const suffix = record?.__operator?.parameters?.__exchangeRateSuffix;

  let label = null;
  if (rate) {
    const symbol = plansService.getCurrencySymbol(suffix);
    const formatted = financialService.formatNumber(rate, { decimals: 2, locale: 'pt-BR' });
    label = `${translateX('exchange_rate')}: ${symbol} ${formatted}`;
  }

  return {
    key: 'exchangeRate',
    icon: <TransactionOutlined />,
    label,
    tooltipText: translateX('exchange_rate'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};
